import { getPressclippings } from '@/graphql/queries/media/pressclipping';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('podcasts.description');
  const subtitle = store.$i18n.t('podcasts.jumbotron.subtitle');
  const title = store.$i18n.t('podcasts.jumbotron.title');
  const page = route.query.page || 1;
  const type = 'podcasts';
  await $apolloQuery(getPressclippings, { type, page }).then(result => {
    store.commit('utils/setPagination', result.meta.pagination);
    store.commit('blog/setPodcasts', result.clippings);
    store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-blog-newsletter-signup', subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title: store.$i18n.t('podcasts.title') });
  });
};
